import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCES_QUERY_KEY, TEMPLATES_QUERY_KEY} from "../queryKeys";

type BatchDeleteTemplatesVariables = {templateIds: number[]; deleteTranslations?: boolean};

const batchDeleteTemplates = async ({
  templateIds,
  deleteTranslations = true,
}: BatchDeleteTemplatesVariables): Promise<boolean> => {
  const response = await axiosReachInstance.post<boolean, AxiosResponse<boolean>>("/templates/batch-delete", {
    template_ids: templateIds,
    delete_translations: deleteTranslations,
  });
  return response.data;
};

export const useBatchDeleteTemplates = (
  options?: BaseMutationOptions<boolean, BatchDeleteTemplatesVariables>
): BaseUseMutationResult<boolean, BatchDeleteTemplatesVariables> => {
  return useBaseMutation<boolean, BatchDeleteTemplatesVariables>(batchDeleteTemplates, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY], [AUDIENCES_QUERY_KEY]],
  });
};
